// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__3PQJj","image":"recipe_image__3s-T5"};